import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css' // optional for styling

// @ts-ignore

window.addEventListener('load', () => {

  document.querySelectorAll('[data-tooltip-history-price]').forEach((elem) => {
    // @ts-ignore
    tippy(elem, {
      content(reference) {
        const template = reference.getAttribute('data-content');
        if (template) {
          return template;
        }
      },
      theme: 'price-history',
      placement: 'right-end',
      arrow: false,
      interactive: true,
      allowHTML: true,
      trigger: 'click',
      appendTo: () => document.body,
      maxWidth: 'none',
    });
  });
});
